import React, { useEffect, useRef } from "react";
import { connect } from "react-redux";
import queryString from "query-string";
import * as actions from "../../actions";
import FaSpinner from "../../../components/faSpinner/faSpinner";

import { parseOAuthParameters } from "../../constants/parse/oauth";
import dependencies from "../../dependencies";

const { oAuthRedirectUrl } = dependencies;

function LoginHOC(props) {
  const { fetchOauthParameters, storeReturnUrl, location, oAuth } = props;
  // oAuthParameters is persisted (redux-persist) and also fetched by other pages, so a
  // state already in the store may have been consumed by an earlier callback or have
  // expired. The Core binds each state to the browser with a cookie set by
  // authorization-info, so only redirect with the state this visit's call returned.
  const staleState = useRef(oAuth?.parameters.state);
  const redirected = useRef(false);

  useEffect(() => {
    fetchOauthParameters();
  }, []);

  useEffect(() => {
    // parseOAuthParameters returns a new object on every render; redirect only once.
    const state = oAuth?.parameters.state;
    if (state && state !== staleState.current && !redirected.current) {
      redirected.current = true;
      authenticate();
    }
  }, [oAuth]);

  function authenticate() {
    const { returnTo } = queryString.parse(location.search);
    const nonce = oAuth.parameters.state;
    storeReturnUrl({ nonce, returnTo });
    window.location.href = encodeURI(
      oAuth.baseUrl +
        "?client_id=" +
        oAuth.parameters.client_id +
        "&scope=" +
        oAuth.parameters.scope +
        "&redirect_uri=" +
        oAuthRedirectUrl +
        "&response_mode=query" +
        "&response_type=" +
        oAuth.parameters.response_type +
        "&state=" +
        nonce
    );
  }

  const { loading } = props;
  return loading ? <FaSpinner loading /> : null;
}

const mapStateToProps = (state) => ({
  loading: state.applicationUser?.loading,
  oAuth: parseOAuthParameters(state.applicationUser?.oAuthParameters),
});

const mapDispatchToProps = (dispatch) => ({
  fetchOauthParameters: (userInfo) => {
    dispatch(actions.fetchOauthParameters(userInfo));
  },
  storeReturnUrl: (userInfo) => {
    dispatch(actions.storeReturnUrl(userInfo));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginHOC);
